
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GAnimetion.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from "../../CommonImports";

function GEmployersSubheader() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    return (
        <section className="section-box">
            <div className="box-head-single box-head-single-candidate">
                <div className="container">
                    <div className="heading-image-rd online">
                        <a href="#">
                            <figure><img alt="jobhub" src={mediaUrl + "employer-12.png?" + sasToken}/></figure>
                        </a>
                    </div>
                    <div className="heading-main-info">
                        <h4>Behance Studio</h4>
                        <div className="head-info-profile">
                            <span className="text-small mr-20"><i className="fi-rr-marker text-mutted"></i> Chicago, US</span>
                            <span className="text-small mr-20"><i className="fi-rr-briefcase text-mutted"></i> Ui/UX design</span>
                            <span className="text-small"><i className="fi-rr-clock text-mutted"></i> $45 / hour</span>
                            <div className="rate-reviews-small">
                               <span>
                                    <img alt="jobhub" src={`${mediaUrl}star.svg?${sasToken}`} />
                                </span>
                                <span>
                                    <img alt="jobhub" src={`${mediaUrl}star.svg?${sasToken}`} />
                                </span>
                                <span>
                                    <img alt="jobhub" src={`${mediaUrl}star.svg?${sasToken}`} />
                                </span>
                                <span>
                                    <img alt="jobhub" src={`${mediaUrl}star.svg?${sasToken}`} />
                                </span>
                                <span>
                                    <img alt="jobhub" src={`${mediaUrl}star.svg?${sasToken}`} />
                                </span>
                                <span className="ml-10 text-muted text-small">(5.0)</span>
                            </div>
                        </div>
                        <div className="row align-items-end">
                            <div className="col-lg-6">
                                <a href="#" className="btn btn-tags-sm mb-10 mr-5">Figma</a>
                                <a href="#" className="btn btn-tags-sm mb-10 mr-5">Adobe XD</a>
                                <a href="#" className="btn btn-tags-sm mb-10 mr-5">PSD</a>
                                <a href="#" className="btn btn-tags-sm mb-10 mr-5">App</a>
                                <a href="#" className="btn btn-tags-sm mb-10 mr-5">Digital</a>
                            </div>
                            <div className="col-lg-3">
                                <a href="#" className="btn btn-default">Download CV</a>
                            </div>
                            <div className="col-lg-3 text-lg-end">
                                <ul className="breadcrumbs mt-10">
                                    <li><a href="#">Home</a></li>
                                    <li>Danica Lewis</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )

}
export default GEmployersSubheader;